import React from 'react';
import latestPosts from '../latestPosts.json';

// "From the blog" row on the landing page — portaled into #widget-mount-blog
// (see Home.jsx). latestPosts.json is written by globalnow-blog-publisher.py
// after every post (write_latest_posts()), so a normal globalnow deploy always
// ships whatever the 3 most recent posts are at build time.
const LatestBlogRow = () => {
  if (!latestPosts || latestPosts.length === 0) return null;
  return (
    <div>
      <div className="grid3" style={{ marginTop: 28 }}>
        {latestPosts.map((p) => (
          <a
            key={p.slug}
            href={`/blog/${p.slug}/`}
            className="card"
            style={{ display: 'block', textDecoration: 'none', color: 'inherit' }}
          >
            <div className="ic">📰</div>
            <h3>{p.title}</h3>
            <p>{p.desc}</p>
          </a>
        ))}
      </div>
      <p className="microtrust" style={{ marginTop: 20 }}>
        <a href="/blog/">See all posts →</a>
      </p>
    </div>
  );
};

export default LatestBlogRow;
